export default __webpack_public_path__ + "static/payment_buttons_2rows-898a1529d8df0b0b927c035b140e63ed.svg";